export const InvoiceStatus = {
  Draft: 'Draft',
  Checked: 'Checked',
  Charged: 'Charged',
  Paid: 'Paid',
};

export function isInvoiceStatusChangeAvailable(currentInvoiceStatus, newInvoiceStatus) {
  switch (currentInvoiceStatus) {
    case InvoiceStatus.Draft:
      switch (newInvoiceStatus) {
        case InvoiceStatus.Checked:
          return true;
        default:
          return false
      }
    case InvoiceStatus.Checked:
      switch (newInvoiceStatus) {
        case InvoiceStatus.Draft:
        case InvoiceStatus.Charged:
          return true;
        default:
          return false
      }
    case (InvoiceStatus.Charged):
      switch (newInvoiceStatus) {
        case InvoiceStatus.Paid:
          return true;
        default:
          return false
      }
    case (InvoiceStatus.Paid):
      return false; // terminal state
    default:
      throw(new Error(`Unknown invoice status '${currentInvoiceStatus}'`));
  }
}



// WEBPACK FOOTER //
// ./src/services/invoice.js